<div [class]="classes">
    <input class="form-input" type="text" [formControl]="control" (selectItem)="onSelect($event)" [editable]="editable"
        [inputFormatter]="formatter" [resultFormatter]="formatter" [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)" (click)="click$.next($any($event).target.value)"
        [ngClass]="{'error':hasErrors()}" #instance="ngbTypeahead">
</div>